module.exports = __webpack_public_path__ + "static/img/waterage.b68ed57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/waterage.png
// module id = Z8iv
// module chunks = 44